import { useCallback, useState } from 'react'
import ModalBase from 'LuxKit/Modal/ModalBase'
import useModalElementContext from 'hooks/Modal/useModalElementContext'
import type { ChooseDoubleRewardsChoice } from '../utils/loyaltyChooseDoubleRewardsState'
import LoyaltySelectRewardChoiceContent from './LoyaltySelectRewardChoiceContent'
import LoyaltyConfirmRewardChoiceContent from './LoyaltyConfirmRewardChoiceContent'
import useLoyaltyChooseDoubleRewardsEnrolmentState from '../hooks/useLoyaltyChooseDoubleRewardsEnrolmentState'

function LoyaltyChooseDoubleRewardsFlowModal() {
  const modal = useModalElementContext()
  const [choice, setChoice] = useState<ChooseDoubleRewardsChoice>()
  const [confirming, setConfirming] = useState(false)

  const { pending: isEnrolmentPending } = useLoyaltyChooseDoubleRewardsEnrolmentState(choice)

  // Initial selection step
  const continueSelection = useCallback((selected: ChooseDoubleRewardsChoice) => {
    setChoice(selected)
    setConfirming(true)
  }, [])

  const dismiss = useCallback(() => {
    if (!isEnrolmentPending) {
      modal.resolve()
    }
  }, [modal, isEnrolmentPending])

  const back = useCallback(() => {
    setConfirming(false)
  }, [])

  const isChoiceSelectionComplete = confirming && choice

  // Shared modal base across the two steps
  return <ModalBase size="S" dismissible={!isEnrolmentPending} onClose={dismiss}>
    {!isChoiceSelectionComplete && <LoyaltySelectRewardChoiceContent initialSelection={choice} onContinue={continueSelection} />}
    {isChoiceSelectionComplete && <LoyaltyConfirmRewardChoiceContent choice={choice} onBack={back} />}
  </ModalBase>
}

export default LoyaltyChooseDoubleRewardsFlowModal
